export var LABELS;
(function (LABELS) {
    LABELS["SKILL"] = "SKILL";
    LABELS["CHANNEL"] = "CHANNEL";
    LABELS["DOMAIN"] = "DOMAIN";
    LABELS["FLOW"] = "FLOW";
    LABELS["MEMORY"] = "MEMORY";
})(LABELS || (LABELS = {}));
export var RELATIONSHIP;
(function (RELATIONSHIP) {
    RELATIONSHIP["IMPLEMENTS"] = "IMPLEMENTS";
    RELATIONSHIP["INCLUDES"] = "INCLUDES";
    RELATIONSHIP["REMEMBERS"] = "REMEMBERS";
})(RELATIONSHIP || (RELATIONSHIP = {}));
//# sourceMappingURL=common.js.map